import BulletListDialog from './BulletListDialog.vue'

export default BulletListDialog
